/* eslint-disable react/jsx-props-no-spreading */
import { FilledInputProps, InputProps, OutlinedInputProps } from '@mui/material';
import TextField from '@mui/material/TextField';
import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import React, { useContext, useRef } from 'react';
import { v4 as uuid } from 'uuid';
import { SettingsContext } from '../../contexts';

export interface ETODateFieldProps
  extends Omit<DatePickerProps<
  Dayjs, Dayjs>,
    'value' | 'renderInput' | 'onChange' | 'onAccept'
>{
  id?: string;
  autoFocus?: boolean;
  name: string;
  error?: string;
  label?: string;
  disabled?: boolean;
  clearable?: boolean;
  value?: any;
  requireValue?: boolean;
  // eslint-disable-next-line no-unused-vars
  handleChange?: (val?: Dayjs | null) => void;
  size?: 'small' | 'medium';
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  // eslint-disable-next-line no-unused-vars
  onAccept?: (val?: Dayjs | null) => void;
  onClose?: () => void;
  onKeyDown?: React.KeyboardEventHandler<
  HTMLInputElement | HTMLTextAreaElement>;
}

type InputProp = Partial<InputProps> | Partial<FilledInputProps> | Partial<OutlinedInputProps>

const ETODateField = (props: ETODateFieldProps) => {
  const {
    id,
    name,
    label,
    disabled,
    error,
    value,
    handleChange,
    requireValue,
    inputFormat,
    autoFocus,
    size,
    onFocus,
    onAccept,
    onClose,
    onKeyDown,
    onBlur,
    ...rest
  } = props;

  const idRef = useRef(id ?? uuid());

  const { settings } = useContext(SettingsContext);

  const controlProps = {
    ...rest,
    id: idRef.current,
    name,
    disabled: disabled ?? false,
    clearable: !requireValue,
    inputFormat: inputFormat === '' ? 'dd/MM/YY' : inputFormat ?? settings.dateFormat,
    value,
    onChange: (date: Dayjs | null) => {
      if (handleChange) handleChange(date);
    },
    onAccept,
    onClose,
    InputProps: {
      autoFocus,
      id: idRef.current,
      variant: 'outlined',
      label: label ?? undefined,
      size: size ?? 'medium',
      onFocus,
      onKeyDown,
      onBlur,
    } as InputProp,
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        renderInput={
          (params) => (
            <TextField
              fullWidth
              {...params}
              required={requireValue}
              helperText={error}
              error={Boolean(error)}
              name={label}
            />
          )
        }
        {...controlProps}
      />
    </LocalizationProvider>
  );
};

export default ETODateField;
